// extracted by mini-css-extract-plugin
module.exports = {"title":"content_title__cwetI","graph":"content_graph__3orkA","labels":"content_labels__1luzA","label":"content_label__3sId4"};